import { IconCircle } from "@veneer/core";
import React from "react";
import { useTranslation } from "react-i18next";

type Props = {
  value: number;
};

export const CheckInIcon: React.FC<Props> = ({ value }) => {
  const { t } = useTranslation("global");

  const iconMap: Record<number, { color: string; label: string }> = {
    1: {
      color: "#00D072",
      label: t("header.earlyCheckIn"),
    },
    2: {
      color: "#FFC000",
      label: t("header.lateCheckIn"),
    },
    3: {
      color: "#BCBABA",
      label: t("header.scheduledDayOff"),
    },
    4: {
      color: "#F87C63",
      label: t("header.noScheduledAgendaOrAbsence"),
    },
    5: {
      color: "#ffffffff",
      label: "",
    },
    6: {
      color: "#E4080A",
      label: t("header.unjustifiedAbsence"),
    },
    7: {
      color: "#508AFD",
      label: t("header.absenceVacation"),
    },
    8: {
      color: "#508AFD",
      label: t("header.absenceHoliday"),
    },
    10: {
      color: "#508AFD",
      label: t("header.absenceDisability"),
    },
    11: {
      color: "#508AFD",
      label: t("header.absenceLeave"),
    },
    12: {
      color: "#508AFD",
      label: t("header.absenceHomeOffice"),
    },
    13: {
      color: "#508AFD",
      label: t("header.absenceSanction"),
    },
    14: {
      color: "#508AFD",
      label: t("header.absenceRobbery"),
    },
    15: {
      color: "#508AFD",
      label: t("header.absenceTraining"),
    },
    17: {
      color: "#508AFD",
      label: t("header.absenceInduction"),
    },
  };

  const config = iconMap[value];
  if (!config) return null;

  if (config.color === "#ffffffff") {
    return (
      <span title={config.label}>
        <IconCircle size={25} />
      </span>
    );
  }

  return (
    <span title={config.label}>
      <IconCircle filled customStyle={{ color: config.color }} size={25} />
    </span>
  );
};
